






















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "icon",
  props: {
    path: String,
  },
})
export default class Modal extends Vue {
  @Prop() public title!: string;
  @Prop() public show!: boolean;
  @Prop() public modalWidth!: number;
  // @Prop() public hide!: boolean;
  constructor() {
    super();
  }
  close() {
    this.show = false;
    this.$emit("close", this.show);
  }

  mounted() {
    // console.log("value = " + this.show);
  }
}
